import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.pdf-viewer-divider { border-color: ${dt('pdfViewer.divider.color')}; }
.pdf-viewer-canvas { background-color: ${dt('pdfViewer.canvas.background')}; }
.pdf-viewer-thumbnail-current {
  border-color: ${dt('pdfViewer.thumbnail.current.borderColor')};
  background-color: ${dt('pdfViewer.thumbnail.current.background')};
}
.pdf-viewer-thumbnail-idle { border-color: ${dt('pdfViewer.thumbnail.idle.borderColor')}; }
@media (hover: hover) {
  .pdf-viewer-thumbnail-idle:hover { border-color: ${dt('pdfViewer.thumbnail.idle.hoverBorderColor')}; }
}
`;
